import { render, staticRenderFns } from "./StockStallionDistant.vue?vue&type=template&id=726da55e&"
import script from "./StockStallionDistant.vue?vue&type=script&lang=js&"
export * from "./StockStallionDistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports